<template>
    <div class="main-layout">
        <v-app id="inspire">
            <Navigation/>
            <v-content>
                <v-container fluid pa-0>
                    <child />
                </v-container>
            </v-content>
            <Footer/>
        </v-app>
    </div>
</template>

<script>
    import Navigation from "@/components/Navigation";
    import Footer from "@/components/Footer";

    export default {
        name: 'MainLayout',

        components: {
            Navigation, Footer
        }
    }
</script>
